import { getTrimmedFields } from "../../../../utils/formaters";
import { ELIGIBILITY_QUESTIONNAIRE_FIELD_NAME } from "../constants";

const applyTrimFields = (form, fieldsToExclude = []) => {
  const formFieldValues = form.getFieldsValue();

  fieldsToExclude.forEach((field) => delete formFieldValues[field]);

  const trimmedFields = getTrimmedFields(formFieldValues);
  form.setFieldsValue(trimmedFields);
};

const cleanEmptyStringValuesFromQuestionnaire = (form) => {
  const formFieldValues = form.getFieldsValue();
  const questionnaire = formFieldValues[ELIGIBILITY_QUESTIONNAIRE_FIELD_NAME];

  if (typeof questionnaire === "object" && questionnaire !== null) {
    const cleanedQuestionnaire = Object.fromEntries(
      Object.entries(questionnaire).map(([key, value]) => [key, value === "" ? undefined : value])
    );

    form.setFieldsValue({ [ELIGIBILITY_QUESTIONNAIRE_FIELD_NAME]: cleanedQuestionnaire });
  }
};

export { applyTrimFields, cleanEmptyStringValuesFromQuestionnaire };
